import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
/**
 *  Custom core module used to declare custom components, services, models, utilities ....
 *  This file will not be replaced by Palmyra Generator
 */
@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [],
  providers: [],
})
export class CustomCoreModule {}
